import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexColumn)`
    width: 100%;
    gap: 12px;
`;

export const Title = styled.div`
    ${setFontVariant("listItem1", colorsPalettes.carbon[500])};
`;
